import { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AdminAppBar from "../../../adminComponents/AdminAppBar";
import BackArrows from "../../../Form/BackArrow/BackArrows";
import StepProgress from "../StepProgress";
import { getIcons, userUid } from "../../../Constant/Constant";
import { TbFileSymlink } from "react-icons/tb";
import { MdAddCircleOutline } from "react-icons/md";
import PropertiesService from "../../../Services/PropertiesService";
import { FiSearch } from "react-icons/fi";
import { LiaFilterSolid } from "react-icons/lia";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../Constant/Notification";
import { toast, ToastContainer } from "react-toastify";
import {
  plotStatusIds,
  propertySaleTypes,
  PropertyTypeList,
  roadFacingSides,
} from "../../../../Enum";
import StatusDropdown from "../StatusDropdown";

import VillaUnitTable from "./VillaUnitTable";
import VillaPropertyInfoForm from "./VillaPropertyInfoForm";
import VillaUnitForm from "./VillaUnitForm";
import BulkUploadModel from "../BulkUploadModel";
import * as XLSX from "xlsx";
import { userRole } from "../../../../utils/storage";

const VillaProertyManage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    selectedPropertyDetails,
    propertySaleType,
    propertyId,
    propertyName,
    propertyTypeId,
    selectedSaleName,
    propertyInfoStatus = false,
  } = location.state || {};

  const editMode = !!propertyId;

  const propertySaleTypesName = propertySaleTypes.find(
    (item) => item.id === propertySaleType
  )?.label;
  console.log("propertySaleTypesName Details:", propertySaleTypesName);

  const icons = getIcons();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [editingUnit, setEditingUnit] = useState(null);
  const [isNewUnit, setIsNewUnit] = useState(false);
  const [totalUnitRow, setTotalUnitRow] = useState(0);
  const [previousTotalUnitRow, setPreviousTotalUnitRow] = useState(0);
  const [filteredUnits, setFilteredUnits] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [isLoading, setIsLoading] = useState(false);

  const [validationErrors, setValidationErrors] = useState([]);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [insertedCount , setInsertedCount] = useState(0);
  const [skippedCount , setSkippedCount] = useState(0);
  const [skippedUnitsInfo, setSkippedUnitsInfo] = useState({
    skippedCount: 0,
    skippedUnitNos: []
  });
  const [showSkippedUnitsModal, setShowSkippedUnitsModal] = useState(false);


  const [propertyInfo, setPropertyInfo] = useState({
    docId: "",
    name: "",
    locationId: "",
    propertyId: "",
    geoLocation: "",
    propertyTypeId: selectedPropertyDetails?.id || "",
    propertySaleTypeId: propertySaleType || "",
    propertyType: selectedPropertyDetails?.label || "",
    propertySaleName: selectedSaleName || "",
    underOfGovernance: "",
    salesTeamIds: [],
    basicAmenitiesIds: [],
    futureAmenitiesIds: [],
    nearByAmenitiesIds: [],
    possessionDate: "",
    propertyImages: [],
    propertyVideos: [],
    propertyDocuments: [],
    ageOfTheProperty: 0,
    propertyFlyers: [],
    propertyBlueprints: [],
    propertyThumbnail: "",
    overAllSqft: 0,
    dtcpNo: "",
    guidelineValue: 0,
    documentType: "",
    landmark: "",
    roiPercentage: "",
    roiYear: "",
    reraId: "",
    surveyFee: 0,
    surveyNo: "",
    documentCharge: 0,
    purchaseDaysCount: 0,
    propertyPurchasedDate: "",
    sro: "",
    taluk: "",
    address: "",
    locationLink: "",
    totalProjectWorth: 0,
    propertySellerName: "",
    propertySellerPhoneNumber: "",
    createdById: userUid,
    modifiedById: "",
    overAllSaleableSqft: 0,
    totalAvailableUnits: 0,
    overAllAvailableSqft: 0,
    availableMinSqft: 0,
    availableMaxSqft: 0,
    availableMinBudget: 0,
    availableMaxBudget: 0,
    bookedUnitcount: 0,
    overAllBookedSqft: 0,
    agreementUnitcount: 0,
    overAllAgreementSqft: 0,
    registeredUnitcount: 0,
    overAllRegisteredSqft: 0,
    constructionType: "",
    openParkingCharge: 0,
    semiCoveredParkingCharge: 0,
    fullyCoveredParkingCharge: 0,
    commission: 0,

    driveLink : "",
    propertyVendorName : "",
    propertyVendorPhoneNumber : "",
  });

  const [units, setUnits] = useState([]);
  const [modifiedUnitIds, setModifiedUnitIds] = useState(new Set());

  const filterUnits = useCallback(() => {
    let filtered = units.filter((unit) => unit !== null && unit !== undefined);

    if (searchTerm.trim()) {
      filtered = filtered.filter((unit) =>
        unit.unitNo?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (selectedStatus !== "all") {
      filtered = filtered.filter(
        (unit) =>
          unit.unitStatus?.name.toLowerCase() === selectedStatus.toLowerCase()
      );
    }

    if (editMode) {
      if (!(editMode && previousTotalUnitRow === 0)) {
        setTotalUnitRow(filtered.length);
      }
    }

    //  setTotalUnitRow(filtered.length);
    setFilteredUnits(filtered);
  }, [units, searchTerm, selectedStatus]);

  // useEffect(() => {
  //   filterUnits();
  // }, [filterUnits]);

  useEffect(() => {
    filterUnits();
  }, [units, selectedStatus, searchTerm]);

  useEffect(() => {
    const fetchData = async () => {
      if (editMode && propertyId && propertyTypeId) {
        try {
          const propertyResponse = await PropertiesService.getPropertyById(
            propertyId,
            propertyTypeId
          );
          const apiData = propertyResponse.data?.propertyData || {};

          setPropertyInfo({
            ...propertyInfo,
            docId: propertyId,
            name: apiData.name || "",
            locationId: apiData.location?.id || "",
            geoLocation: apiData.geoLocation || "",
            propertyId: apiData.propertyId || "",
            propertyType:
              apiData.propertyType?.name ||
              selectedPropertyDetails?.label ||
              "",
            propertyTypeId:
              apiData.propertyType?.id || selectedPropertyDetails?.id || "",
            propertySaleTypeId:
              apiData.propertySaleType?.id || propertySaleType || "",
            underOfGovernance: apiData.underOfGovernance || "",
            salesTeamIds: Array.isArray(apiData.salesTeam)
              ? apiData.salesTeam.map((team) => team.id)
              : [],
            basicAmenitiesIds: Array.isArray(apiData.basicAmenities)
              ? apiData.basicAmenities.map((amenity) => amenity.id)
              : [],
            futureAmenitiesIds: Array.isArray(apiData.futureAmenities)
              ? apiData.futureAmenities.map((amenity) => amenity.id)
              : [],
            nearByAmenitiesIds: Array.isArray(apiData.nearByAmenities)
              ? apiData.nearByAmenities.map((amenity) => amenity.id)
              : [],
            propertyImages: Array.isArray(apiData.propertyImages)
              ? apiData.propertyImages.map((img) => img.doc)
              : [],
            propertyVideos: Array.isArray(apiData.propertyVideos)
              ? apiData.propertyVideos.map((video) => video.doc)
              : [],
            propertyDocuments: Array.isArray(apiData.propertyDocuments)
              ? apiData.propertyDocuments.map((doc) => doc.doc)
              : [],
            propertyFlyers: Array.isArray(apiData.propertyFlyers)
              ? apiData.propertyFlyers.map((flyer) => flyer.doc)
              : [],
            propertyBlueprints: Array.isArray(apiData.propertyBlueprints)
              ? apiData.propertyBlueprints.map((bp) => bp.doc)
              : [],
            propertyThumbnail: apiData.propertyThumbnail || "",
            overAllSqft: apiData.overAllSqft || 0,
            dtcpNo: apiData.dtcpNo || "",
            guidelineValue: apiData.guidelineValue || 0,
            documentType: apiData.documentType || "",
            landmark: apiData.landmark || "",
            purchaseDaysCount: apiData.purchaseDaysCount || 0,
            roiPercentage: apiData.roiPercentage || "",
            roiYear: apiData.roiYear || "",
            reraId: apiData.reraId || "",
            ageOfTheProperty: apiData.ageOfTheProperty || 0,
            surveyFee: apiData.surveyFee || 0,
            surveyNo: apiData.surveyNo || "",
            documentCharge: apiData.documentCharge || 0,
            propertyVendorName : apiData.propertyVendorName || "",
            propertyVendorPhoneNumber : apiData.propertyVendorPhoneNumber || "",
            driveLink : apiData.driveLink || "",
            propertyPurchasedDate: apiData.propertyPurchasedDate || "",
            possessionDate: apiData.possessionDate || "",
            constructionType: apiData.constructionType || "",
            sro: apiData.sro || "",
            taluk: apiData.taluk || "",
            address: apiData.address || "",
            locationLink: apiData.locationLink || "",
            totalProjectWorth: apiData.totalProjectWorth || 0,
            propertySellerName: apiData.propertySellerName || "",
            propertySellerPhoneNumber: apiData.propertySellerPhoneNumber || "",
            overAllSaleableSqft: apiData.overAllSaleableSqft || 0,
            totalAvailableUnits: apiData.totalAvailableUnits || 0,
            overAllAvailableSqft: apiData.overAllAvailableSqft || 0,
            availableMinSqft: apiData.availableMinSqft || 0,
            availableMaxSqft: apiData.availableMaxSqft || 0,
            availableMinBudget: apiData.availableMinBudget || 0,
            availableMaxBudget: apiData.availableMaxBudget || 0,
            bookedUnitcount: apiData.bookedUnitcount || 0,
            overAllBookedSqft: apiData.overAllBookedSqft || 0,
            agreementUnitcount: apiData.agreementUnitcount || 0,
            overAllAgreementSqft: apiData.overAllAgreementSqft || 0,
            registeredUnitcount: apiData.registeredUnitcount || 0,
            overAllRegisteredSqft: apiData.overAllRegisteredSqft || 0,
            propertySaleName: apiData.propertySaleType?.name || "",
            commission: apiData.commission || 0,
            semiCoveredParkingCharge: apiData.semiCoveredParkingCharge || 0,
            openParkingCharge: apiData.openParkingCharge || 0,
            fullyCoveredParkingCharge: apiData.fullyCoveredParkingCharge || 0,
          });

          const unitsResponse =
            await PropertiesService.getVillaUnitsByPropertyId(propertyId);

          const unitsData = unitsResponse.data?.units || [];

          setUnits(unitsData);
          setPreviousTotalUnitRow(unitsData.length);

          setTotalUnitRow(Math.max(unitsData.length, 0));
        } catch (error) {
          console.error("Error fetching data:", error);
          showErrorToast("Failed to load property or unit data");
        }
      }
    };
    fetchData();
  }, [propertyId, editMode]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    
    if (!searchTerm.trim()) {
      // If search is empty, reset filters to show all units
      setSelectedStatus("all");
    }
    
   // filterUnits();
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setSelectedStatus("all");
    filterUnits();
  };

  const handleStatusFilter = (option) => {
    setSelectedStatus(option.id === "all" ? "all" : option.label);
  };

  const handlePropertyInfoChange = (e) => {
    const { name, value } = e.target;
    setPropertyInfo((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === "geoLocation") {
        const coords = value.split(",").map((c) => c.trim());
        if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
          updated.locationLink = `https://www.google.com/maps?q=${coords[0]},${coords[1]}`;
        } else {
          updated.locationLink = "";
        }
      }
      return updated;
    });
  };

  const handleArrayFieldChange = (field, newArray) => {
    setPropertyInfo((prev) => ({
      ...prev,
      [field]: newArray,
    }));
  };

  const handleNestedPropertyInfoChange = (parentKey, childKey, value) => {
    setPropertyInfo((prev) => ({
      ...prev,
      [parentKey]: {
        ...prev[parentKey],
        [childKey]: value,
      },
    }));
  };

  const handlePrevStep = () => {
    if (totalUnitRow > previousTotalUnitRow) {
      showErrorToast(
        "Cannot go back in previous steps. Please add or remove units to proceed."
      );
    } else {
      if (currentStep > 1) setCurrentStep(currentStep - 1);
    }
  };

  const handleNextViewStep = () => {
    setCurrentStep(2);
  };

  const handlePrevViewStep = () => {
    if (totalUnitRow > previousTotalUnitRow) {
      showErrorToast(
        "Cannot go back in previous steps. Please add or remove units to proceed."
      );
    } else {
      if (currentStep > 1) setCurrentStep(currentStep - 1);
    }
  };

  const handleNextStep = async () => {
    if (isLoading) return;
    if (!propertyInfo.name.trim()) {
      showErrorToast("Property name is required!");
      return;
    }
    // if (propertyInfo?.overAllSqft <= 0) {
    //   showErrorToast("Overall Square Feet is required!");
    //   return;
    // }
    // if (propertyInfo?.guidelineValue <= 0) {
    //   showErrorToast("Guideline Value is required!");
    //   return;
    // }
    if (propertyInfo.geoLocation.trim() === "") {
      showErrorToast("Latitude and longitude are required!");
      return;
    }
    if (propertyInfo.locationId.trim() === "") {
      showErrorToast("Location is required!");
      return;
    }
    if (propertyInfo.address.trim() === "") {
      showErrorToast("Address is required!");
      return;
    }

    setIsLoading(true);

    try {
      let savedPropertyId = propertyInfo.docId;
      let propertyPayload = {
        name: propertyInfo.name || null,
        locationId: propertyInfo.locationId || null,
        geoLocation: propertyInfo.geoLocation || null,
        propertyTypeId: propertyInfo?.propertyTypeId || null,
        propertySaleTypeId: propertyInfo.propertySaleTypeId || null,
        underOfGovernance: propertyInfo.underOfGovernance || null,
        salesTeamIds: Array.isArray(propertyInfo.salesTeamIds)
          ? propertyInfo.salesTeamIds
          : [propertyInfo.salesTeamIds].filter(Boolean),
        basicAmenitiesIds: Array.isArray(propertyInfo.basicAmenitiesIds)
          ? propertyInfo.basicAmenitiesIds
          : [propertyInfo.basicAmenitiesIds].filter(Boolean),
        futureAmenitiesIds: Array.isArray(propertyInfo.futureAmenitiesIds)
          ? propertyInfo.futureAmenitiesIds
          : [propertyInfo.futureAmenitiesIds].filter(Boolean),
        nearByAmenitiesIds: Array.isArray(propertyInfo.nearByAmenitiesIds)
          ? propertyInfo.nearByAmenitiesIds
          : [propertyInfo.nearByAmenitiesIds].filter(Boolean),
        propertyImages: Array.isArray(propertyInfo.propertyImages)
          ? propertyInfo.propertyImages
          : [propertyInfo.propertyImages].filter(Boolean),
        propertyVideos: Array.isArray(propertyInfo.propertyVideos)
          ? propertyInfo.propertyVideos
          : [propertyInfo.propertyVideos].filter(Boolean),
        propertyDocuments: Array.isArray(propertyInfo.propertyDocuments)
          ? propertyInfo.propertyDocuments
          : [propertyInfo.propertyDocuments].filter(Boolean),
        propertyFlyers: Array.isArray(propertyInfo.propertyFlyers)
          ? propertyInfo.propertyFlyers
          : [propertyInfo.propertyFlyers].filter(Boolean),
        propertyBlueprints: Array.isArray(propertyInfo.propertyBlueprints)
          ? propertyInfo.propertyBlueprints
          : [propertyInfo.propertyBlueprints].filter(Boolean),
        propertyThumbnail: propertyInfo.propertyThumbnail || null,
        overAllSqft: (propertyInfo.overAllSqft) || "",
        dtcpNo: propertyInfo.dtcpNo || null,
        guidelineValue: Number(propertyInfo.guidelineValue) || 0,
        documentType: propertyInfo.documentType || null,
        landmark: propertyInfo.landmark || null,
        roiPercentage: Number(propertyInfo.roiPercentage) || null,
        roiYear: Number(propertyInfo.roiYear) || null,
        reraId: propertyInfo.reraId || null,
        surveyFee: Number(propertyInfo.surveyFee) || 0,
        ageOfTheProperty: Number(propertyInfo.ageOfTheProperty) || 0,
        surveyNo: propertyInfo.surveyNo || null,
        documentCharge: Number(propertyInfo.documentCharge) || 0,
        propertyPurchasedDate: propertyInfo.propertyPurchasedDate || null,
        sro: propertyInfo.sro || null,
        possessionDate: propertyInfo.possessionDate || null,
        taluk: propertyInfo.taluk || null,
        address: propertyInfo.address || null,
        locationLink: propertyInfo.locationLink || null,
        totalProjectWorth: Number(propertyInfo.totalProjectWorth) || 0,
        propertySellerName: propertyInfo.propertySellerName || null,
        propertySellerPhoneNumber:
          propertyInfo.propertySellerPhoneNumber || null,
        constructionType: propertyInfo.constructionType || null,
        openParkingCharge: Number(propertyInfo.openParkingCharge) || null,
        semiCoveredParkingCharge:
          Number(propertyInfo.semiCoveredParkingCharge) || null,
        fullyCoveredParkingCharge:
          Number(propertyInfo.fullyCoveredParkingCharge) || null,
        commission: Number(propertyInfo.commission) || null,

        propertyVendorName: propertyInfo.propertyVendorName || null,
        propertyVendorPhoneNumber : propertyInfo.propertyVendorPhoneNumber || null,
        driveLink : propertyInfo.driveLink || null,
        isReadyToSales : true,
        
      };

      if (editMode) {
        propertyPayload = {
          ...propertyPayload,
          docId: propertyInfo.docId,
          modifiedById: userUid || null,
        };
        await PropertiesService.updateProperty(propertyPayload);
        toast.success("Property updated successfully!", {
          autoClose: 1000,
          position: "top-center",
          onClose: () => {
            setIsLoading(false);
            setCurrentStep(2);
          },
        });
      } else {
        propertyPayload = {
          ...propertyPayload,
          createdById: userUid || null,
          prospectPropertyId : null,
        };
        const response = await PropertiesService.createProperty(
          propertyPayload
        );
        savedPropertyId = response.data.id;
        setPropertyInfo((prev) => ({ ...prev, docId: savedPropertyId }));
        showSuccessToast("Property created successfully!");
      }
      setCurrentStep(2);
    } catch (error) {
      console.error("Error saving property:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddUnit = () => {
    const defaultStatus = plotStatusIds.find(
      (status) => status.label === "Available"
    );

    setEditingUnit({
      order: units.length + 1,
      unitNo: "",
      carpetArea: 0,
      buildUpArea: 0,
      terraceArea: 0,
      saleableArea: 0,
      guidelineSqftPrice: 0,
      floors: 0,
      totalBhk: 0,
      basePrice: 0,
      baseRate: 0,
      allInclusiveCharges: 0,
      // floorsBhk: [],
      bathrooms: "",
      roadFacingSide: "",
      //totalPrice: 0,
      registrationCharge: 0,
      furnished: "",
      parking: "",
      coveredParking: "",
      lift: "",
      swimmingPool: "",
      villaViewType: "",
      notes: "",
      statusName: defaultStatus?.label,
      unitStatus: defaultStatus
        ? { id: defaultStatus.id, name: defaultStatus.label }
        : { id: "", name: "N/A" },
      createdBy: userUid,
    });
    setIsNewUnit(true);
    setIsSliderOpen(true);
  };

  const handleEditUnit = (unit) => {
    setEditingUnit({
      ...unit,
      floorsBhk:
        unit.floorsBhk ||
        Array(unit.floors || 0)
          .fill()
          .map((_, i) => ({
            floor: i + 1,
            bhk: unit.floorsBhk?.[i]?.bhk || 0,
          })),
    });
    setIsNewUnit(false);
    setIsSliderOpen(true);
  };

  const handleUnitFormChange = (e) => {
    const { name, value } = e.target;

    setEditingUnit((prev) => {
      if (name === "unitStatus") {
        const selectedStatus = plotStatusIds.find(
          (status) => status.id === value
        );
        return {
          ...prev,
          unitStatus: {
            id: value,
            name: selectedStatus ? selectedStatus.label : "",
          },
        };
      }

      if (name === "roadFacingSide") {
        const selectedSide = roadFacingSides.find((side) => side.id === value);
        return {
          ...prev,
          roadFacingSide: {
            id: value,
            name: selectedSide ? selectedSide.label : "",
          },
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleFloorsChange = (e) => {
    const floors = Number(e.target.value);
    setEditingUnit((prev) => {
      const newFloorsBhk = Array(floors)
        .fill()
        .map((_, i) => ({
          floor: i + 1,
          bhk: prev.floorsBhk?.[i]?.bhk || 0,
        }));
      const totalBhk = newFloorsBhk.reduce(
        (sum, item) => sum + Number(item.bhk),
        0
      );
      return {
        ...prev,
        floors,
        floorsBhk: newFloorsBhk,
        totalBhk,
      };
    });
  };

  const handleFloorBhkChange = (index, value) => {
    setEditingUnit((prev) => {
      const newFloorsBhk = [...prev.floorsBhk];
      newFloorsBhk[index] = { ...newFloorsBhk[index], bhk: Number(value) };
      const totalBhk = newFloorsBhk.reduce(
        (sum, item) => sum + Number(item.bhk),
        0
      );
      return {
        ...prev,
        floorsBhk: newFloorsBhk,
        totalBhk,
      };
    });
  };

  const handleApplyToAllUnits = () => {
    const fieldsToApply = {
      guidelineSqftPrice: editingUnit.guidelineSqftPrice,
      registrationCharge: editingUnit.registrationCharge,
      furnished: editingUnit.furnished,
      parking: editingUnit.parking,
      coveredParking: editingUnit.coveredParking,
      lift: editingUnit.lift,
      swimmingPool: editingUnit.swimmingPool,
      villaViewType: editingUnit.villaViewType,
    };

    setUnits((prevUnits) =>
      prevUnits.map((unit, index) =>
        unit
          ? {
              ...unit,
              ...fieldsToApply,
              isModified: true,
              order: index + 1,
            }
          : null
      )
    );

    setModifiedUnitIds(new Set(units.map((unit) => unit?.id).filter(Boolean)));
    showSuccessToast("Applied settings to all units!");
    setIsSliderOpen(false);
    setEditingUnit(null);
  };

  const handleSaveUnit = async () => {
    console.log(editingUnit);
    if (!editingUnit.unitNo.trim()) {
      showErrorToast("Unit number is required!");
      return;
    }
    if (
      units.some(
        (unit) =>
          unit &&
          unit.unitNo === editingUnit.unitNo &&
          unit.id !== editingUnit.id
      )
    ) {
      showErrorToast("Unit number already exists!");
      return;
    }
    if (editingUnit.unitNo.length > 30) {
      showErrorToast("Unit number cannot exceed 30 characters!");
      return;
    }
    if (!editingUnit.buildUpArea || editingUnit.buildUpArea <= 0) {
      showErrorToast("Build-Up Area must be greater than 0!");
      return;
    }
    // if (Number(editingUnit.carpetArea) > 0) {
    //   if (editingUnit.buildUpArea < editingUnit.carpetArea) {
    //     showErrorToast("Build-Up Area cannot be less than Carpet Area!");
    //     return;
    //   }
    // }
    // if (Number(editingUnit.saleableArea) < Number(editingUnit.buildUpArea)) {
    //   showErrorToast("Saleable Area should be greater than Build-Up Area!");
    //   return;
    // }
    if (!editingUnit?.saleableArea || editingUnit.saleableArea <= 0) {
      showErrorToast("Saleable Area must be greater than 0!");

      return;
    }

    if (editingUnit.floors <= 0 || editingUnit.floors > 6) {
      showErrorToast("Number of floors must be between 1 and 6!");
      return;
    }
    if (editingUnit.totalBhk <= 0 || editingUnit.totalBhk > 10) {
      showErrorToast("Total BHK must be between 1 and 10!");
      return;
    }
    if (!editingUnit.baseRate || editingUnit.baseRate <= 0) {
      showErrorToast("Base Rate must be greater than 0!");
      return;
    }

    if (!editingUnit.roadFacingSide) {
      showErrorToast("Road facing side is required!");
      return;
    }

    try {
      const unitToSave = {
        ...editingUnit,
        propertyId: propertyInfo.docId,
        createdBy: userUid,
        modifiedBy: userUid,
      };

      if (isNewUnit) {
        setUnits((prevUnits) => {
          const newUnits = [...prevUnits];
          const orderIndex = editingUnit.order - 1;
          const newUnit = {
            ...unitToSave,
            id: `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
            isNew: true,
          };

          while (orderIndex >= newUnits.length) {
            newUnits.push(null);
          }

          newUnits[orderIndex] = newUnit;

          if (orderIndex >= totalUnitRow) {
            setTotalUnitRow(orderIndex + 1);
          }

          return newUnits;
        });
      } else {
        setUnits((prevUnits) => {
          const updatedUnits = prevUnits.map((unit) =>
            unit && unit.id === editingUnit.id
              ? { ...unitToSave, isModified: true }
              : unit
          );
          setModifiedUnitIds((prev) => new Set([...prev, editingUnit.id]));
          return updatedUnits;
        });
      }
      filterUnits();
      setIsSliderOpen(false);
      setEditingUnit(null);
      // showSuccessToast(`Unit ${isNewUnit ? "added" : "updated"} successfully!`);
    } catch (error) {
      console.error("Error saving unit:", error);
      showErrorToast(`Failed to ${isNewUnit ? "add" : "update"} unit!`);
    }
  };

  const handleCancelUnitEdit = () => {
    setIsSliderOpen(false);
    setEditingUnit(null);
  };

  const handleSavePropertyVillaUnit = async () => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const validUnits = units.filter(
        (unit) =>
          unit &&
          unit.unitNo?.trim() &&
          unit.buildUpArea > 0 &&
          !unit.isArchived
      );

      if (validUnits.length === 0 && units.some((unit) => unit !== null)) {
        showErrorToast(
          "All units must have a valid unit number and build-up area!"
        );
        return;
      }

      const updatedUnits = validUnits.map((unit, index) => ({
        ...unit,
        order: index + 1,
      }));

      const newUnits = updatedUnits.filter(
        (unit) => !unit.id || unit.id.startsWith("temp-")
      );
      const existingUnits = updatedUnits.filter(
        (unit) => unit.id && !unit.id.startsWith("temp-")
      );

      const formatUnit = (unit, isExisting) => ({
        ...(isExisting
          ? { docId: unit.id, modifiedBy: userUid }
          : { createdBy: userUid }),
        unitNo: unit.unitNo?.trim() || null,
        order: unit.order,
        carpetArea: unit.carpetArea && Number(unit.carpetArea) > 0 ? Number(unit.carpetArea) : null,

        baseRate: unit.baseRate && Number(unit.baseRate) > 0 ? Number(unit.baseRate) : null,
        saleableArea: unit.saleableArea && Number(unit.saleableArea) > 0 ? Number(unit.saleableArea) : null,
        basePrice:
          unit.baseRate && unit.saleableArea && Number(unit.baseRate) > 0 && Number(unit.saleableArea) > 0
            ? Number((Number(unit.baseRate) * Number(unit.saleableArea)).toFixed(2))
            : null,
        allInclusiveCharges: unit.allInclusiveCharges && Number(unit.allInclusiveCharges) > 0 ? Number(unit.allInclusiveCharges) : null,
        buildUpArea: unit.buildUpArea && Number(unit.buildUpArea) > 0 ? Number(unit.buildUpArea) : null,
        terraceArea: unit.terraceArea && Number(unit.terraceArea) > 0 ? Number(unit.terraceArea) : null,
     ///]   guidelineSqftPrice: Number(unit.guidelineSqftPrice) || 0,
        floors: unit.floors && Number(unit.floors) > 0 ? Number(unit.floors) : null,
        totalBhk: unit.totalBhk && Number(unit.totalBhk) > 0 ? Number(unit.totalBhk) : null,
        notes: unit.notes?.trim() || null,
        bathrooms: unit.bathrooms && Number(unit.bathrooms) > 0 ? Number(unit.bathrooms) : null,
        roadFacingSideId: unit.roadFacingSide?.id || null,

        registrationCharge: unit.registrationCharge && Number(unit.registrationCharge) > 0 ? Number(unit.registrationCharge) : null,
        furnished: unit.furnished?.trim() || null,
        furnishedCharge:
          unit.furnished === "Unfurnished"
            ? null
            : unit.furnishedCharge && Number(unit.furnishedCharge) > 0 ? Number(unit.furnishedCharge) : null,
        preferredLocationCharge: unit.preferredLocationCharge && Number(unit.preferredLocationCharge) > 0 ? Number(unit.preferredLocationCharge) : null,
        electricityCharge: unit.electricityCharge && Number(unit.electricityCharge) > 0 ? Number(unit.electricityCharge) : null,
        parking: unit.parking?.trim() || null,
        coveredParking: unit.coveredParking?.trim() || null,
        lift: unit.lift?.trim() || null,
        swimmingPool: unit.swimmingPool?.trim() || null,
        villaViewType: unit.villaViewType?.trim() || null,
        unitStatusId: unit.unitStatus?.id || null,

        governmentGuideline: unit.governmentGuideline && Number(unit.governmentGuideline) > 0 ? Number(unit.governmentGuideline) : null,
        vendorGuideline: unit.vendorGuideline && Number(unit.vendorGuideline) > 0 ? Number(unit.vendorGuideline) : null,
    
      });

      if (newUnits.length > 0) {
        const createPayload = {
          docId: propertyInfo.docId,
          units: newUnits.map((unit) => formatUnit(unit, false)),
        };

        await PropertiesService.createVillaUnit(createPayload);
      }

      if (existingUnits.length > 0) {
        const updatePayload = {
          docId: propertyInfo.docId,
          units: existingUnits.map((unit) => formatUnit(unit, true)),
        };

        await PropertiesService.updateVillaUnit(updatePayload);
      }

      if (propertyInfo.docId) {
        const response = await PropertiesService.getVillaUnitsByPropertyId(
          propertyInfo.docId
        );
        const refreshedUnits = response.data?.units || [];

        setUnits(refreshedUnits);
        setUnits((prev) =>
          refreshedUnits.map((unit, index) =>
            unit ? { ...unit, totalPrice: unit?.totalPrice || 0 } : null
          )
        );

        setTotalUnitRow(Math.max(refreshedUnits.length, totalUnitRow));
        setModifiedUnitIds(new Set());
      }

      showSuccessToast(
        `Property and units ${editMode ? "updated" : "created"} successfully!`
      );
      setTimeout(() => {
        navigate(-1);
      }, 1700);
    } catch (err) {
      console.error("Error saving property and units:", err);
      // showErrorToast(
      //   `Failed to ${editMode ? "update" : "create"} property and units!`
      // );
    } finally {
      setIsLoading(false);
    }
  };

  const getIdByLabel = (list, label) => {
    if (!label || !Array.isArray(list)) return "";
    const match = list.find(
      (item) => item.label?.toLowerCase().trim() === label.toLowerCase().trim()
    );
    return match?.id || "";
  };

  const handleBulkUploadVillaUnits = async (input) => {
    const file = input instanceof File ? input : input?.target?.files?.[0];
    if (!file || !(file instanceof Blob)) {
      showErrorToast("Invalid file format or no file selected.");
      return;
    }

    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];

        const rawData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

        const jsonData = rawData.map((row) => {
          const cleanedRow = {};
          Object.entries(row).forEach(([key, value]) => {
            const trimmedKey = key.trim().replace(/\s+/g, " ");
            cleanedRow[trimmedKey] = value;
          });
          return cleanedRow;
        });

        if (!jsonData.length) {
          showErrorToast("Uploaded Excel is empty.");
          return;
        }

        if (jsonData.length > 200) {
          setValidationErrors(["Only 200 rows are allowed."]);
          setShowValidationModal(true);
          return;
        }

        const seenUnits = new Set();
        const errors = [];

        const formattedUnits = jsonData.map((row, index) => {
          const rowNum = index + 2;
          const unitNo = row["Unit Number"]?.toString().trim() || "";

          if (!unitNo) {
            errors.push(`Row ${rowNum}: Unit Number is required.`);
          } else if (seenUnits.has(unitNo)) {
            errors.push(`Row ${rowNum}: Duplicate Unit Number "${unitNo}"`);
          } else {
            seenUnits.add(unitNo);
          }

          const requiredFields = [
            "Saleable Area",
            "Build-up Area",
            "Floors",
            "Total BHK",
            "Base Rate",
            "Status",
            "Unit Facing Side",
          ];

          requiredFields.forEach((field) => {
            if (
              row[field] === undefined ||
              row[field] === null ||
              row[field].toString().trim() === ""
            ) {
              errors.push(`Row ${rowNum}: ${field} is required.`);
            }
          });

          return {
            unitNo,
            order: index + 1,
            saleableArea: Number(row["Saleable Area"]) || 0,
            buildUpArea: Number(row["Build-up Area"]) || 0,
            floors: Number(row["Floors"]) || 0,
            totalBhk: Number(row["Total BHK"]) || 0,
            baseRate: Number(row["Base Rate"]) || 0,
            basePrice:
              Number(row["Base Rate"]) * Number(row["Saleable Area"]) || 0,
            unitStatusId: getIdByLabel(plotStatusIds, row["Status"]),
            roadFacingSideId: getIdByLabel(
              roadFacingSides,
              row["Unit Facing Side"]
            ),
           // guidelineSqftPrice: Number(row["Guideline SQ. FT Price"]) || 0,
            registrationCharge: Number(row["Registration Charge"]) || 0,
            allInclusiveCharges: Number(row["All Inclusive Charges"]) || 0,
            electricityCharge: Number(row["Electricity Charge"]) || 0,
            furnished: row["Furnished"] || "",
            furnishedCharge: row["Furnished Charge"] || "",
            carpetArea: Number(row["Carpet Area"]) || 0,
            terraceArea: Number(row["Terrace Area"]) || 0,
            bathrooms: Number(row["Bathrooms"]) || 0,
            parking: row["Parking"] || "",
            coveredParking: row["Covered Parking"] || "",
            lift: row["Lift"] || "",
            swimmingPool: row["Swimming Pool"] || "",
            villaViewType: row["Villa View Type"] || "",
            notes: row["Notes"] || "",
            preferredLocationCharge : Number(row["Preferred Location Charge"]) || 0,
            createdBy: userUid,
            governmentGuideline : Number(row["Guideline Govt. Value"]) || 0,
            vendorGuideline : Number(row["Guideline Vendor Value"]) || 0,
    
          };
        });

        if (errors.length > 0) {
          setValidationErrors(errors);
          setShowValidationModal(true);
          setSelectedFile(null);
          return;
        }

        const payload = {
          docId: propertyInfo.docId,
          units: formattedUnits,
        };

        const response = await PropertiesService.createVillaUnit(payload);

        if(response.status === 200) {
          showSuccessToast(response?.data?.message);
          setInsertedCount(response.data?.insertedCount);

            setSkippedUnitsInfo({
              skippedCount: response.data.skippedCount,
              skippedUnitNos: response.data.skippedUnitNos || []
            });
            setShowSkippedUnitsModal(true);
          
          setSelectedFile(null);
        }

        const refresh = await PropertiesService.getVillaUnitsByPropertyId(
          propertyInfo.docId
        );
        const refreshedUnits = refresh.data?.units || [];

        setUnits(refreshedUnits);
        setTotalUnitRow(Math.max(refreshedUnits.length, totalUnitRow));
        setModifiedUnitIds(new Set());



        // showSuccessToast("Villa units uploaded successfully!");

        // setTimeout(() => {
        //   navigate(-1);
        // }, 2000);
      } catch (err) {
        console.error("Bulk upload villa units error:", err);
        showErrorToast("Failed to upload villa units.");
      } finally {
        setIsLoading(false);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleTotalUnitRowChange = (e) => {
    const newValue = parseInt(e.target.value) || 0;
    const actualUnitCount = units.filter((unit) => unit !== null).length;

    if (newValue < actualUnitCount) {
      showErrorToast(
        `Cannot set total units below ${actualUnitCount} as there are existing units.`
      );
      setTotalUnitRow(actualUnitCount);
    } else {
      setTotalUnitRow(newValue);
    }
  };

  const handleOneStep = () => {
    setCurrentStep(1);
  };
  const handleTwoStep = () => {
    alert("This is step 2");
    setCurrentStep(2);
  };
  const handleThreeStep = () => {
    setCurrentStep(3);
  };

  return (
    <div className="bg-appGrayBackground min-h-screen pb-16">
      <AdminAppBar />
      <ToastContainer />
      <div className="mt-20 pt-8 px-6 mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-center gap-6 mb-4 md:mb-0">
            <BackArrows onClick={handleBack} />
            <h1 className="text-2xl md:text-3xl font-semibold">
              {selectedPropertyDetails?.label || propertyName}
            </h1>
          </div>
          <div className="flex gap-4">
            {currentStep === 1 && (
              <button
                disabled={isLoading}
                className={`px-6 py-3 w-44 text-center ${
                  isLoading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-customGreen"
                } text-white flex items-center justify-center gap-2 rounded-[10px] transition duration-300`}
                onClick={handleNextStep}
              >
                {propertyName ? "Update Property" : "Next & Publish"}
              </button>
            )}

            {currentStep === 2 && (
              <>
                {/* Show search and filters when editing existing data with units OR when search term is not empty OR when a filter is applied */}
                {((editMode && totalUnitRow > 0) || searchTerm.trim() || selectedStatus !== "all") && (
                  <>
                    <form
                      onSubmit={handleSearchSubmit}
                      className="relative w-full md:w-[385px]"
                    >
                      <input
                        type="text"
                        placeholder="Search Unit Number"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="w-full pl-3 pr-24 h-[50px] shadow appearance-none border rounded-[10px] text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      />
                     
                      <button
                        type="submit"
                        className="absolute right-0 w-[50px] h-[50px] top-1/2 transform -translate-y-1/2 text-white bg-customGreen p-2 rounded-r-[10px] hover:bg-green-600 transition-colors"
                        
                      >
                        <FiSearch className="mx-auto" />
                      </button>
                    </form>

                    <StatusDropdown
                      onSelect={handleStatusFilter}
                      options={[
                        { id: "all", label: "All Statuses" },
                        ...plotStatusIds,
                      ]}
                    />
                  </>
                )}

                {/* Show bulk upload when not editing or when no search term, no filter, and no units */}
                {(!editMode || (!searchTerm.trim() && selectedStatus === "all" && totalUnitRow === 0)) && (
                  <button
                    disabled={isLoading}
                    className={`px-6 py-3 w-44 text-center ${
                      isLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-customGreen"
                    } text-white flex text-nowrap items-center justify-center gap-2 rounded-[10px] transition duration-300`}
                    onClick={() => {
                      setShowBulkModal(true);
                    }}
                  >
                    <TbFileSymlink className="text-xl" />
                    <span>Bulk Upload</span>
                  </button>
                )}

                <button
                  disabled={isLoading}
                  className={`px-6 py-3 w-44 text-center ${
                    isLoading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-customGreen"
                  } text-white flex items-center text-nowrap justify-center gap-2 rounded-[10px] transition duration-300`}
                  onClick={handleSavePropertyVillaUnit}
                >
                  <MdAddCircleOutline className="text-xl font-semibold" />
                  {editMode ? "Update & Finish" : "Save & Finish"}
                </button>
              </>
            )}
          </div>
        </div>

        <div className="bg-white mt-14 rounded-lg py-[30px]">
          <div
            className={`${
              propertyName ? "flex items-center justify-between px-8" : ""
            }`}
          >
            <StepProgress
              currentStep={currentStep}
              handlePrevStep={handlePrevStep}
              handleNextStep={handleNextStep}
              handleNextViewStep={handleNextViewStep}
              handlePrevViewStep={handlePrevViewStep}
              handleOneStep={handleOneStep}
              handleTwoStep={handleTwoStep}
              handleThreeStep={handleThreeStep}
              isEdit={propertyInfoStatus}
              propertyType={propertySaleType}
            />

            {/* {propertyName && currentStep === 1 && (
              <div>
                <button
                  className="px-6 py-3 w-44 text-center bg-customGreen text-white rounded-md"
                  onClick={handleNextStep}
                >
                  Update
                </button>
              </div>
            )} */}
          </div>

          {currentStep === 1 && (
            <VillaPropertyInfoForm
              propertyInfo={propertyInfo}
              setPropertyInfo={setPropertyInfo}
              handlePropertyInfoChange={handlePropertyInfoChange}
              handleArrayFieldChange={handleArrayFieldChange}
              handleNestedPropertyInfoChange={handleNestedPropertyInfoChange}
              isEdit={editMode}
              propertyType={propertyInfo?.propertyType}
              propertySaleTypesName={propertySaleTypesName}
            />
          )}

          {currentStep === 2 && (
            <>
              <div className="flex items-center justify-end absolute right-6 top-[250px]  mr-6">
                <div className="flex items-center gap-3 p-2 bg-white rounded-md border-2 border-slate-200">
                  <label className="flex items-center text-sm font-medium text-gray-700 whitespace-nowrap">
                    <span className="inline-block w-1.5 h-4 bg-red-400 rounded-sm mr-2"></span>
                    Total No. of Units
                  </label>
                  {/* <input
                    type="number"
                    name="totalUnitRow"
                    min={units.filter((unit) => unit !== null).length}
                    value={totalUnitRow}
                    onChange={handleTotalUnitRowChange}
                    placeholder="Number of Units"
                    disabled={units.length > 0}
                    className="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm input-focus transition duration-150 ease-in-out"
                  /> */}
                  <input
                    type="number"
                    name="totalUnitRow"
                  
                    
                    value={totalUnitRow === 0 ? "" : totalUnitRow}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,2}$/.test(value)) {
                        handleTotalUnitRowChange(e);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                     onWheel={(e) => e.target.blur()}
            
                    placeholder="Units No"
                    disabled={editMode && units.length > 0}
                    className="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm input-focus transition duration-150 ease-in-out no-arrow"
                  />
                </div>
              </div>

              <VillaUnitTable
                units={filteredUnits}
                totalUnitRow={totalUnitRow}
                onEdit={handleEditUnit}
                onAdd={handleAddUnit}
              />

              {isSliderOpen && editingUnit && (
                <VillaUnitForm
                  isSliderOpen={isSliderOpen}
                  onHide={handleCancelUnitEdit}
                  unit={editingUnit}
                  handleChange={handleUnitFormChange}
                  handleUnitFormChange={handleUnitFormChange}
                  handleSave={handleSaveUnit}
                  handleCancel={handleCancelUnitEdit}
                  handleFloorsChange={handleFloorsChange}
                  handleFloorBhkChange={handleFloorBhkChange}
                  handleApplyToAll={handleApplyToAllUnits}
                  isNew={isNewUnit}
                />
              )}
            </>
          )}
        </div>
      </div>
      <BulkUploadModel
        open={showBulkModal}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        onClose={() => {
          setShowBulkModal(false);
          setSelectedFile(null);
        }}
        onImport={handleBulkUploadVillaUnits}
        fileLink={"/Villa Bulk Upload.xlsx"}
        fileName="Villa Bulk Upload.xlsx"
      />

      {showValidationModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-lg p-6 max-w-2xl w-full shadow-lg">
            <h2 className="text-xl font-bold mb-4 text-red-600">
              Validation Errors
            </h2>
            <ul className="max-h-80 overflow-y-auto list-disc pl-5 text-sm text-gray-700">
              {validationErrors.map((error, idx) => (
                <li key={idx} className="mb-1">
                  {error}
                </li>
              ))}
            </ul>
            <div className="mt-4 text-right">
              <button
                className="bg-red-600 text-white px-4 py-2 rounded "
                onClick={() => {
                  setShowValidationModal(false);
                  setSelectedFile(null);
                  setValidationErrors([]);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}


{showSkippedUnitsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-4 rounded-xl shadow-xl w-full max-w-md overflow-hidden">
            {/* Header */}

            <div className="flex bg-slate-100 p-2 rounded-md justify-between items-center mb-6">
              <h2
                id="bulk-upload-title"
                className="text-lg font-medium text-green-700"
              >
               Units Uploaded Status 
              </h2>
              <button
              onClick={() => {
                setShowSkippedUnitsModal(false)
                navigate(-1);
              }}
                className="text-red-600 bg-white  focus:outline-none rounded-full p-2"
                aria-label="Close modal"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Content */}
            <div className="">
              {/* Summary Cards */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="bg-green-5 border text-center border-green-100 rounded-lg p-3">
                  <div className="text-green-800 font-medium text-sm">
                    Successful
                  </div>
                  <div className="text-2xl font-bold text-green-600">
                    {insertedCount}
                  </div>
                  <div className="text-green-500 text-xs">units inserted</div>
                </div>
                <div className="bg-yellow-0 border text-center border-yellow-100 rounded-lg p-3">
                  <div className="text-yellow-800 font-medium text-sm">
                    Skipped
                  </div>
                  <div className="text-2xl font-bold text-yellow-600">
                    {skippedUnitsInfo.skippedCount}
                  </div>
                  <div className="text-yellow-500 text-xs">duplicate units</div>
                </div>
              </div>

              {/* Skipped Units List */}
              {skippedUnitsInfo.skippedCount > 0 && (
                <div className="mb-4">
                  <h3 className="text-sm font-medium text-gray-700 mb-2 flex items-center">
                    <svg
                      className="w-4 h-4 mr-1 text-yellow-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Duplicate units found:
                  </h3>

                  <div className="border border-gray-200 rounded-lg overflow-hidden">
                    <div className="max-h-48 overflow-y-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                          <tr>
                            <th
                              scope="col"
                              className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Unit No.
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {skippedUnitsInfo.skippedUnitNos.map(
                            (unitNo, index) => (
                              <tr key={index} className="hover:bg-gray-50">
                                <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
                                  {unitNo}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {/* Footer */}
              <div className="flex justify-end pt-4 border-t border-gray-200">
                <button
                  onClick={() => {
                    setShowSkippedUnitsModal(false);
                    navigate(-1);
                  }}
                  className="px-6 py-2 bg-customGreen text-white rounded-lg  transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VillaProertyManage;
